<div
  class="currency-field"
  [ngClass]="{
    'has-value': internalFormControl.value !== undefined,
    condensed: condensed
  }"
>
  <label
    class="currency-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
    [attr.for]="fieldId"
    type="text"
  >
    {{ label }}
  </label>

  <div class="currency-wrapper">
    <input
      class="currency-input"
      [ngClass]="{ invalid: formControl?.dirty && formControl?.invalid }"
      [attr.data-e2e-id]="e2eId"
      focusable
      tabindex="0"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      [formatAsNumber]="formatAsNumberOptions"
      type="text"
      [attr.id]="fieldId"
      [value]="initialValue"
      [formControl]="internalFormControl"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      (onBlur)="onBlur.emit()"
      (onFocus)="onFocus.emit()"
    />

    <app-error-message
      [fieldControl]="formControl"
      [errorMessage]="errorMessage"
    >
    </app-error-message>
  </div>
</div>
